import { FilterMultiSelectContent } from "@/components/filters/FilterMultiSelectContent";
import { useLocationsStore } from "@/modules/locations/locationsStore";

interface OpportunityLocationFilterContentProps {
  selected: string[];
  onChange: (next: string[]) => void;
}

/**
 * Dropdown body for the Location filter: a searchable multi-select of the org's
 * locations.
 * @param selected - Currently selected location ids
 * @param onChange - Called with the next selected location ids
 * @returns The location-filter dropdown content
 */
export function OpportunityLocationFilterContent({
  selected,
  onChange,
}: OpportunityLocationFilterContentProps) {
  const locations = useLocationsStore((state) => state.locations);

  // Store insertion order depends on what loaded first; sort for a stable list.
  const sortedLocations = Array.from(locations.values()).sort((a, b) =>
    a.name.localeCompare(b.name),
  );

  return (
    <FilterMultiSelectContent
      items={sortedLocations}
      selected={selected}
      onChange={onChange}
      placeholder="Search locations..."
      emptyText="No locations found."
    />
  );
}
